import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { AllocationViewProfileListFacade } from '../list/allocation-view-profile-list.facade';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewProfileListGuard {
  constructor(private allocationViewProfileListFacade: AllocationViewProfileListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.allocationViewProfileListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.allocationViewProfileListFacade);
  }
}
